import { render, staticRenderFns } from "./AttendanceEnquiryDetail.vue?vue&type=template&id=106afc4a&scoped=true"
import script from "./AttendanceEnquiryDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceEnquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./AttendanceEnquiryDetail.vue?vue&type=style&index=0&id=106afc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106afc4a",
  null
  
)

export default component.exports